import { AnimaliaListingCardTagDTO } from '../../../../../application/mappers/AnimaliaListingMapper';
import { buildAnimaliaTaxonomyCanonicalRoute } from '../../../../../application/taxonomy/AnimaliaNavigableTaxonomy';
import { animaliaListingDesignTokens } from '../../shared/animalia-listing-design-tokens';

export class MvAnimaliaListingCardTags extends HTMLElement {
  private tags: ReadonlyArray<AnimaliaListingCardTagDTO> = [];

  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  setTags(tags: ReadonlyArray<AnimaliaListingCardTagDTO>): void {
    this.tags = [...tags];
    this.render();
  }

  connectedCallback(): void {
    this.render();
  }

  private render(): void {
    if (!this.shadowRoot) {
      return;
    }

    this.shadowRoot.innerHTML = `
      <style>
        ${animaliaListingDesignTokens}

        .tag-row {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin-top: 18px;
        }

        .tag {
          display: grid;
          gap: 4px;
          padding: 10px 12px;
          border-radius: 14px;
          background: rgba(244, 239, 231, 0.82);
          border: 1px solid rgba(49, 70, 61, 0.12);
          min-width: 140px;
        }

        .tag-link {
          text-decoration: none;
        }

        .tag-link .tag {
          cursor: pointer;
          text-align: left;
          color: inherit;
          transition: transform 180ms ease, border-color 180ms ease, background 180ms ease;
        }

        .tag-link:hover .tag,
        .tag-link:focus-visible .tag {
          transform: translateY(-1px);
          border-color: rgba(49, 70, 61, 0.34);
          background: rgba(236, 229, 217, 0.96);
          outline: none;
        }

        strong {
          color: #5a6d62;
          font-size: 0.73rem;
          text-transform: uppercase;
          letter-spacing: 0.12em;
          margin: 0;
        }
      </style>

      <div class="tag-row">
        ${this.tags
          .map(
            (tag) => this.renderTag(tag),
          )
          .join('')}
      </div>
    `;
  }

  private renderTag(tag: AnimaliaListingCardTagDTO): string {
    const content = `
      <span class="tag">
        <strong>${this.escapeHtml(tag.label)}</strong>
        ${this.escapeHtml(tag.value)}
      </span>
    `;

    if (!tag.filterKey) {
      return content;
    }

    return `
      <a
        class="tag-link"
        href="${this.escapeAttribute(
          buildAnimaliaTaxonomyCanonicalRoute(tag.filterKey, tag.value),
        )}"
        aria-label="Filtrar por ${this.escapeAttribute(tag.label)} ${this.escapeAttribute(tag.value)}"
      >
        ${content}
      </a>
    `;
  }

  private escapeHtml(value: string): string {
    return value
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#39;');
  }

  private escapeAttribute(value: string): string {
    return this.escapeHtml(value);
  }
}

if (!customElements.get('mv-animalia-listing-card-tags')) {
  customElements.define('mv-animalia-listing-card-tags', MvAnimaliaListingCardTags);
}
